import { useEffect, useRef, useState } from 'react'

type Params = {
  tolerance: number
}

export default function useScrollDirection(params?: Params): 'up' | 'down' {
  const toleranceRef = useRef<number>(0)
  toleranceRef.current = params?.tolerance ?? 0

  const [direction, setDirection] = useState<'up' | 'down'>('down')
  const directionRef = useRef<'up' | 'down'>('down')
  const windowTop = useRef(
    typeof window !== 'undefined' ?
      window.pageYOffset - toleranceRef.current :
      0,
  )

  useEffect(() => {
    function onScroll() {
      const tolerance = toleranceRef.current
      const windowBottom = windowTop.current + tolerance

      const { pageYOffset } = window

      // Prevent mobile Safari's overscroll bounce from triggering the opposite direction
      //
      // actually I've not fixed the same problem at the bottom but we can get to that if we
      // can get to that if we need to. It's quite expensive to continuously check the height
      // of the client

      const realPageYOffset = Math.max(0, pageYOffset)
      if (realPageYOffset > windowBottom) {
        windowTop.current = realPageYOffset - tolerance
        if (directionRef.current === 'up') {
          directionRef.current = 'down'
          setDirection('down')
        }
      }
      else if (realPageYOffset < windowTop.current) {
        windowTop.current = realPageYOffset
        if (directionRef.current === 'down') {
          directionRef.current = 'up'
          setDirection('up')
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true })

    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return direction
}
